import React, { useEffect, useState } from 'react'
import { Select } from 'antd'
import { Label } from 'reactstrap'
import { getUsers } from '@/utils/apiEndpoints'
import { ProfilePicture } from '../ProfilePicture'
import { Text } from '@/style-guide'
const { Option } = Select

export const HostList = ({ onChange, selected, placeholder, showLabel }) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [hosts, setHosts] = useState(data)
  const loadUsers = async () => {
    setLoading(true)
    try {
      const filters = {
        userType: 'host',
      }
      const userRes = await getUsers(new URLSearchParams(filters).toString())
      if (userRes.result) {
        setData(userRes.result.data)
        setHosts(userRes.result.data)
      } else setData([])
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    loadUsers()
  }, [])
  const onSearch = (inputValue) => {
    setHosts(
      data.filter((user) => {
        const username = `${user.firstName} ${user.lastName}`
        return username.toLowerCase().includes(inputValue.toLowerCase())
      })
    )
  }
  return (
    <>
      {showLabel ? <Label>Hosts</Label> : ''}
      <Select
        showSearch
        mode="multiple"
        placeholder={placeholder || 'Select host'}
        value={selected}
        onChange={onChange}
        loading={loading}
        filterOption={false}
        onSearch={onSearch}
      >
        {hosts &&
          hosts.map((val) => (
            <Option key={val._id} value={val._id}>
              <div style={{ display: 'flex' }}>
                <ProfilePicture user={val} size={20} />
                <Text style={{ marginLeft: '10px' }}>
                  {val.firstName} {val.lastName}
                </Text>
              </div>
            </Option>
          ))}
      </Select>
    </>
  )
}
